import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=163c5102&scoped=true"
import script from "./BaseInputNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInputNumber.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseInputNumber.vue?vue&type=style&index=0&id=163c5102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163c5102",
  null
  
)

export default component.exports